module.exports = __webpack_public_path__ + "static/media/no-img.37f988a5.jpeg";